import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import ObjectivesCreateForm from './ObjectivesCreateForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function ObjectivesCreateView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="TubeOps | Agregar objetivo"
    >
      <Container maxWidth={false}>
        <Header />
        <ObjectivesCreateForm />
      </Container>
    </Page>
  );
}

export default ObjectivesCreateView;
